import bodybuilder from 'bodybuilder'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as ReportUtils from '../utils'
import * as Constants from './constants'
import * as Types from './types'

export const fetchTopTopicsFunction = (event: string, max: number) =>
(community: string, form: Types.FormState) => {
  return Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.Tags,
    bodybuilder().size(0)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .filter(
      'term',
      Elasticsearch.DocumentFieldNames.IncludeInReports,
      true)
    .query(
      'range',
      Elasticsearch.DocumentFieldNames.Created,
      ReportUtils.searchDateRange(form),
    )
    .aggregation(
      'terms',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Text),
      {
        size: max,
      },
      Elasticsearch.DocumentFieldNames.Text,
    )
    .build(),
  )
}

export const fetchTopTopics =
  fetchTopTopicsFunction(Constants.FETCH_TOP_TOPICS, Constants.NUM_TOP_TOPICS)

export const FormActions = Form.createActionsMap(Constants.TOP_TOPICS_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/top-topics/actions.ts